module.exports = __webpack_public_path__ + "img/pukwanF.ded52009.jpg";